export const getFromSessionStorage = (key) => sessionStorage.getItem(key);

export const setToSessionStorage = (key, value) => sessionStorage.setItem(key, value);

export const clearAllSessionStorage = () => sessionStorage.clear();
